export default __webpack_public_path__ + "static/media/251.36a10b79.jpg";